let unauthorizedHandler = null;
let handlingUnauthorized = false;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : null;
}

export function notifyUnauthorized() {
  if (handlingUnauthorized) return;
  if (!unauthorizedHandler) return;
  handlingUnauthorized = true;
  Promise.resolve()
    .then(() => unauthorizedHandler())
    .finally(() => {
      handlingUnauthorized = false;
    });
}
